import React from "react";

interface DashboardProps {
  dashboardUrl: string;
}

const Dashboard: React.FC<DashboardProps> = ({ dashboardUrl }) => {
  return (
    <div className="w-full h-full relative overflow-hidden">
      <iframe
        className="w-full absolute top-0 left-0 border-none"
        style={{ height: "calc(100% + 61px)" }}
        title="Dashboard"
        width="100%"
        height="100%"
        src={dashboardUrl}
        allowFullScreen={true}
      />
    </div>
  );
};

export default Dashboard;
